import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styles from './UserSideBarMenu.module.css';
import { userLogout } from '../../Services/config/globals';
import { logout } from '../../Services/Utils/UserApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { getImage } from '../../Services/Utils/FileApis';
import withUser from '../../common/withUser';

function UserSideBarMenu(props) {
  const { user } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userSideBarMenuOpenStatus, setUserSideBarMenuOpenStatus] = useState(false);
  const [anchorElm, setAnchorElm] = useState(null);

  const openUserSideBarMenu = (e) => {
    setUserSideBarMenuOpenStatus(true);
    setAnchorElm(e.currentTarget);
  };

  const handleAnchorElm = (value) => setAnchorElm(value);

  const handleUserSideBarMenu = (value) => {
    setUserSideBarMenuOpenStatus(value);
  };

  const handleClose = async () => {
    handleUserSideBarMenu(false);
    handleAnchorElm(null);
  };

  const handleLogOut = () => {
    logout()
      .then((res) => {
        if (res.hasError === false) {
          handleClose();
        } else {
          dispatch(notifySet({ type: 'error', message: res.message }));
        }
      })
      .finally(() => {
        userLogout();
        navigate('/login');
        setTimeout(() => {
          dispatch(notifySet({ type: 'success', message: 'Signed Out Successfull' }));
        }, 500);
      });
  };

  const handleChangePassword = () => {
    handleClose();
    user.view.roleView.id === 1 ? navigate('/admin/change-password') : navigate('/startup/change-password');
  };

  return (
    <>
      <div className={`${styles['user-icon-con']}`} onClick={openUserSideBarMenu}>
        <span className={`${styles['user-text-img-box']}`}>
          <img src={getImage(user?.view?.logoView)} alt="" />
        </span>
        <span className={`${styles['user-name-box-con']}`}>Hi, {user?.view.name} </span>
      </div>
      <div className={`${styles['drop-icon-title-menu-con']}`}>
        <Menu
          id="basic-menu"
          className={`${styles['drop-icon-title-menu-ul']}`}
          anchorEl={anchorElm}
          open={userSideBarMenuOpenStatus}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }} // eslint-disable-next-line
          disableScrollLock={true}
        >
          {user?.view.roleView.id === 1 ? (
            ''
          ) : (
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/my-profile');
              }}
            >
              <div className={`${styles['icon-title-full']}`}>
                <div className={`${styles['icon-title-left']}`}>
                  <span className={`${styles['text-img-box']} ${styles['user-text-img-box']}`}>
                    <img src={getImage(user?.view?.logoView)} alt="" />
                  </span>
                </div>
                <div className={`${styles['icon-title-right']}`}>My Profile</div>
              </div>
            </MenuItem>
          )}

          <MenuItem onClick={handleChangePassword}>
            <div className={`${styles['icon-title-full']}`}>
              <div className={`${styles['icon-title-left']}`}>
                <img alt="" src="/assets/images/change-password-icon.svg" />
              </div>
              <div className={`${styles['icon-title-right']}`}>Change Password</div>
            </div>
          </MenuItem>

          <MenuItem onClick={handleLogOut}>
            <div className={`${styles['icon-title-full']}`}>
              <div className={`${styles['icon-title-left']}`}>
                <img alt="" src="/assets/images/logout-icon.svg" />
              </div>
              <div className={`${styles['icon-title-right']}`}>Logout</div>
            </div>
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}

export default withUser(UserSideBarMenu);
